module.exports = __webpack_public_path__ + "54af3c62d2c515ca1598f5130dd132d3.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsolutions/assets/03-Betsolutions-Highlow.png
// module id = 1725
// module chunks = 2